/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content-box[_ngcontent-%COMP%]{height:calc(100% - 50px);overflow:hidden}.element-wrapper[_ngcontent-%COMP%]{height:100%}  .ag-pivot-mode-panel{display:none!important}  .ag-column-select-column-drag-handle{display:none!important}.readonly-cell[_ngcontent-%COMP%]{pointer-events:none}"];
export { styles as styles };
